import { func, string } from 'prop-types';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import ModalContainer from '@components/modals/ModalContainer';

import { CloseButton, ModalHeader, ModalTitle } from '@features/trend-research/components/common/Modal';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { addSectionById } from '@services/trendResearch';

const AddSectionModal = ({ onClose, callBack, title }) => {
	const { id } = useParams();
	const dispatch = useDispatch();
	const [errors, setErrors] = useState({});
	const [sectionTitle, setSectionTitle] = useState('');
	const [sectionDescription, setSectionDescription] = useState('');

	const saveSection = async () => {
		try {
			dispatch(openLoader());
			let postData = { sectionTitle, sectionDescription };
			await addSectionById(id, postData);
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	const handleSubmit = async () => {
		if (sectionTitle) {
			setErrors({});
			await saveSection();
			await callBack();
			onClose();
		} else {
			setErrors({
				title: 'Title is required!'
			});
		}
	};

	return (
		<ModalContainer onCloseModal={onClose} className="add-section-popup">
			<div className="common-popup add-section-popup">
				<ModalHeader>
					<ModalTitle title={title} />
					<CloseButton onClick={onClose} />
				</ModalHeader>
				<div className="common-popup-body">
					<div className="row">
						<div className="col-md-12 pr-2">
							<div className="form-group">
								<label htmlFor="collection">Title</label>
								<input
									type="text"
									className="w-100"
									value={sectionTitle}
									onChange={(e) => setSectionTitle(e.target.value)}
								/>
								{errors?.title && <p className="error">{errors.title}</p>}
							</div>
						</div>
						<div className="col-md-12 pr-2">
							<div className="form-group">
								<label htmlFor="collection">Description</label>
								<textarea
									name=""
									id=""
									value={sectionDescription}
									onChange={(e) => setSectionDescription(e.target.value)}
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button size32 outline" onClick={onClose}>
							Cancel
						</button>
						<button className="button size32 ml-2" onClick={handleSubmit}>
							Create
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

AddSectionModal.propTypes = {
	onClose: func.isRequired,
	callBack: func.isRequired,
	title: string.isRequired
};

export default AddSectionModal;
